import React, { useRef } from 'react';
import { ColorMode, Overlay } from '@landr/maestro';
import ConfirmRemoveAllModal from 'components/Modals/ConfirmRemoveAllModal';
import ConfirmLoadSessionModal from 'components/Modals/ConfirmLoadSessionModal';
import { ShareModal } from 'components/Modals/ShareModal';
import { useCreatorContext } from 'controllers/business/Creator/Creator.controller';
import { Styled } from './Creator.styled';
import CreatorCollapse from './CreatorCollapse/CreatorCollapse';

const TransitionDuration = 500;

export interface CreatorTriggerProps {
    isCreatorOpen: boolean;
    onClick: () => void;
}

const _Creator: React.FC<{
    closeCreator: () => void;
    isCreatorOpen: boolean;
    isVisible: boolean;
}> = ({ closeCreator, isCreatorOpen, isVisible }) => {
    // REFS
    const creatorWrapperRef = useRef<HTMLDivElement>(null);

    return (
        <>
            <ColorMode mode="invert">
                <Overlay
                    isVisible={isCreatorOpen && isVisible}
                    onClick={closeCreator}
                    timeout={TransitionDuration}
                    position="fixed"
                    zIndex={100}
                />
                <Styled.CreatorWrapper
                    isVisible={isVisible}
                    ref={creatorWrapperRef}
                    data-testid="creator"
                >
                    <CreatorCollapse />
                </Styled.CreatorWrapper>
            </ColorMode>
            <ConfirmRemoveAllModal />
            <ConfirmLoadSessionModal />
            <ShareModal />
        </>
    );
};

const Creator: React.FC = () => {
    // CONTEXT
    const { state, closeCreator, isVisible } = useCreatorContext();
    const { isCreatorOpen } = state;

    return (
        <_Creator
            isCreatorOpen={isCreatorOpen}
            closeCreator={closeCreator}
            isVisible={isVisible}
        />
    );
};

export default Creator;
